import {
    CadastroPromocaoFidelidadeActionsTypes,
    type CadastroPromocaoFidelidadeActionModel,
} from "./cadastroPromocaoFidelidadeActions"
import type { CadastroPromocaoFidelidadeModel } from "../models/cadastroPromocaoFidelidadeModel"

export function cadastroPromocaoFidelidadeReducer(
    state: CadastroPromocaoFidelidadeModel,
    action: CadastroPromocaoFidelidadeActionModel
): CadastroPromocaoFidelidadeModel {
    switch (action.type) {
        case CadastroPromocaoFidelidadeActionsTypes.CARREGAR:
            return { ...action.payload }

        case CadastroPromocaoFidelidadeActionsTypes.ATUALIZAR_CAMPO:
            return { ...state, [action.payload.campo]: action.payload.valor }

        default:
            return state
    }
}
